<template>
	<label @click="toDetails" class="videos-card suite flex between">
		<div class="img">
			<img :src="videosInfo.cover" alt />
		</div>
		<div class="flex around-v">
			<p class="title">{{videosInfo.name}}</p>
			<p class="desc">{{videosInfo.remarks}}</p>
			<span class="video flex">{{videosInfo.videoCount}}集</span>
		</div>
	</label>
</template>

<script>
export default {
	props: {
		// [详情,六大知识,完整动作,专项训练]
		type: {},
		videosInfo: {},
	},
	data() {
		return {};
	},
	methods: {
		toDetails() {
			let type = this.type || 0;
			this.$router.push(`/student/videos/details?videosId=${this.videosInfo.id}`);
			// switch (type) {
			// 	case 0:
			// 		this.$router.push(`/student/videos/details`);
			// 		break;
			// 	case 1:
			// 		this.$router.push(`/student/videos/detailssix`);
			// 		break;
			// 	case 2:
			// 		this.$router.push(`/student/videos/detailswhole`);
			// 		break;
			// 	case 3:
			// 		this.$router.push(`/student/videos/detailsspecial`);
			// 		break;
			// 	default:
			// 		break;
			// }
		},
	},
};
</script>

<style lang="less" scoped>
.videos-card {
	margin: 0 0 11 / @rem;
	letter-spacing: 1 / @rem;
	.around-v {
		flex: 1;
		align-items: flex-start;
		p {
			&.title {
				font-size: 17 / @rem;
				color: rgba(49, 49, 49, 1);
				font-weight: bold;
				display: -webkit-box;
				word-break: break-all;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 1;
				overflow: hidden;
			}
			&.desc {
				line-height: 25 / @rem;
				font-size: 13 / @rem;
				color: rgba(49, 49, 49, 0.5);
				display: -webkit-box;
				// word-break: break-all;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 1;
				overflow: hidden;
			}
		}
		span.video {
			font-size: 12 / @rem;
			color: rgba(31, 30, 29, 0.3);
			&::before {
				content: "";
				display: inline-block;
				width: 16 / @rem;
				height: 12 / @rem;
				margin-right: 5 / @rem;
				background-image: url(~@img/icon/ui_video.png);
				background-repeat: no-repeat;
				background-size: cover;
			}
		}
	}

	.img {
		position: relative;
		img {
			min-width: 126 / @rem;
			width: 126 / @rem;
			height: 70 / @rem;
			margin-right: 13 / @rem;
			border-radius: 2 / @rem;
			display: inline-block;
			background-color: #bbbbbb;
		}
		&::before {
			content: "";
			position: absolute;
			display: block;
			top: -6 / @rem;
			width: 80%;
			height: 20 / @rem;
			margin-left: 5%;
			border-radius: 2 / @rem;
			background-color: rgb(255, 239, 199);
			z-index: -2;
		}
		&::after {
			content: "";
			position: absolute;
			display: block;
			top: -3 / @rem;
			width: 86%;
			height: 20 / @rem;
			margin-left: 2%;
			border-radius: 2 / @rem;
			background-color: rgb(255, 197, 107);
			z-index: -2;
		}
	}
}

.suite {
	margin: 20 / @rem 0 11 / @rem;
}
</style>
